// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"629506b5","404":"2fd1372e","668":"5c8fa2ea","930":"24c15ce9"}[chunkId] + ".chunk.js";
};